import * as React from 'react';
import styled from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';
import View from '@sdk/components/primitives/View';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Href from '@sdk/components/ui/Href';
import gettext from '@sdk/lang/gettext';

import { DOWNLOAD_IOS_APP_URL, DOWNLOAD_ANDROID_APP_URL } from '../constants';

const Container = styled(View)`
  padding-top: 10px;
`;
const SmallHelpBlock: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Container>
      <Text14 themeColor={ThemeColorType.iconGray}>Download the Sling app for&nbsp;</Text14>
      <Href
        underline
        themeColor={ThemeColorType.iconGray}
        fontSize={14}
        target="_blank"
        href={DOWNLOAD_IOS_APP_URL}>
        {gettext('iOS')}
      </Href>
      <Text14 themeColor={ThemeColorType.iconGray}>&nbsp;or&nbsp;</Text14>
      <Href
        underline
        themeColor={ThemeColorType.iconGray}
        fontSize={14}
        target="_blank"
        href={DOWNLOAD_ANDROID_APP_URL}>
        {gettext('Android')}
      </Href>
    </Container>
  );
};

export default SmallHelpBlock;
